// The pilot log sheet's stylesheet. A fixed A4-landscape layout (1122 x 790 px
// at 96 dpi, a hair inside the paper so rounding never starts a second page),
// scoped to .pilot-log, in paper colours whatever the app's theme.
// The sheet is mounted beside the app in .pilot-log-print: hidden on screen,
// and the only thing printed.
export const PILOT_LOG_CSS = `
@page { size: A4 landscape; margin: 0 }
.pilot-log-print { display: none }
@media print {
  body > *:not(.pilot-log-print) { display: none !important }
  .pilot-log-print { display: block }
  html, body { margin: 0 !important; padding: 0 !important; background: #fff !important }
}
.pilot-log {
  --ink: #14181d; --muted: #5a626c; --hair: #c5cad1; --head: #e8ebef; --key: #fff6bf;
  --ok: #17692f; --ok-bg: #eaf6ec; --bad: #b3261e;
  width: 1122px; height: 790px; overflow: hidden; position: relative; box-sizing: border-box;
  display: grid; grid-template-columns: 1fr 1fr; background: #fff; color: var(--ink);
  font: 10.5px/1.3 system-ui, -apple-system, 'Segoe UI', sans-serif;
  -webkit-print-color-adjust: exact; print-color-adjust: exact;
}
.pilot-log * { box-sizing: border-box }
.pilot-log .fold { position: absolute; left: 50%; top: 0; bottom: 0; border-left: 1px dashed var(--hair) }
.pilot-log .page { padding: 22px 28px 16px; display: grid; gap: 8px; align-content: start; min-width: 0; min-height: 0; overflow: hidden }
.pilot-log .right { padding-left: 32px; grid-template-rows: auto auto auto auto 1fr auto }
.pilot-log .left { grid-template-rows: none; grid-auto-rows: auto }
.pilot-log .left .pgfoot { align-self: end }
.pilot-log .mono, .pilot-log .num, .pilot-log .com, .pilot-log .f, .pilot-log .fig, .pilot-log .route, .pilot-log .reg {
  font-family: ui-monospace, 'SF Mono', Menlo, Consolas, monospace; font-variant-numeric: tabular-nums;
}
.pilot-log .num { text-align: right }
.pilot-log .tag { font-size: 8.5px; font-weight: 700; letter-spacing: .12em; text-transform: uppercase; color: var(--muted) }
.pilot-log h2 { margin: 0 0 3px; font-size: 9px; font-weight: 700; letter-spacing: .1em; text-transform: uppercase }
.pilot-log table { width: 100%; border-collapse: collapse }
.pilot-log th, .pilot-log td { border: 1px solid var(--hair); padding: 2px 4px; text-align: left; font-weight: 400 }
.pilot-log th { background: var(--head); font-size: 8.5px; font-weight: 600; border-color: var(--ink); white-space: nowrap }

.pilot-log .hd { border-bottom: 2px solid var(--ink); padding-bottom: 6px; display: grid; gap: 4px }
.pilot-log .row1 { display: flex; justify-content: space-between; align-items: baseline; gap: 8px }
.pilot-log .route { font-weight: 600; font-size: 24px; letter-spacing: .02em; line-height: 1 }
.pilot-log .reg { font-weight: 600; font-size: 15px }
.pilot-log .meta { display: flex; flex-wrap: wrap; gap: 1px 14px; color: var(--muted) }
.pilot-log .meta b { color: var(--ink); font-weight: 600 }

.pilot-log .times { display: grid; grid-template-columns: repeat(3, 1fr) 1.1fr; grid-template-rows: 1fr 1fr; gap: 1px; background: var(--ink); border: 1.5px solid var(--ink) }
.pilot-log .times > div { background: #fff; padding: 3px 6px 5px; min-height: 40px; display: grid; align-content: space-between }
.pilot-log .times > .plan { grid-column: 4; grid-row: 1 / span 2; background: var(--head); align-content: start; gap: 3px }
.pilot-log .times label { font-size: 8.5px; font-weight: 600; letter-spacing: .08em; text-transform: uppercase; color: var(--muted) }
.pilot-log .times .fill { border-bottom: 1px solid var(--ink); height: 15px }
.pilot-log .plan .fig { font-weight: 600; font-size: 14px }
.pilot-log .plan .fig small { font-weight: 400; font-size: 8.5px; color: var(--muted) }
.pilot-log .plan .line { font-size: 9.5px; color: var(--muted) }

.pilot-log .nav td { height: 23px }
.pilot-log .nav td.wp { font-family: ui-monospace, 'SF Mono', Menlo, Consolas, monospace; font-weight: 600; font-size: 12px; padding-block: 1px }
.pilot-log .nav td.wp .sub { display: block; font-family: system-ui, sans-serif; font-weight: 400; font-size: 8px; color: var(--muted); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 96px }
.pilot-log .nav.dense td.wp .sub { display: none }
.pilot-log .nav td.mh { font-weight: 700; background: var(--key) }
.pilot-log .nav td.write { border-bottom: 1px solid var(--ink) }
.pilot-log .nav td.com { font-size: 10px }

.pilot-log .box { border: 1px solid var(--ink) }
.pilot-log .box > h2 { background: var(--head); margin: 0; padding: 3px 6px; display: flex; justify-content: space-between; border-bottom: 1px solid var(--ink) }
.pilot-log .box > h2 span { font-family: ui-monospace, Menlo, monospace; font-weight: 600; letter-spacing: 0 }
.pilot-log .box td { border-width: 0 0 1px }
.pilot-log .box tr:last-child td { border-bottom: 0 }
.pilot-log .box tr.key td { background: var(--key); font-weight: 700 }
.pilot-log .speeds td { white-space: nowrap; font-size: 9.5px }
.pilot-log .fq td { font-size: 10px; padding-block: 2px }
.pilot-log .fq td.n { font-weight: 600; font-family: ui-monospace, Menlo, monospace; width: 52px }
.pilot-log .item { margin-right: 12px; white-space: nowrap }
.pilot-log .airspace { margin: 0; padding: 0; list-style: none }
.pilot-log .airspace li { display: grid; grid-template-columns: 78px 1fr auto; gap: 6px; padding: 2px 6px; border-bottom: 1px solid var(--hair); font-size: 10px; align-items: baseline }
.pilot-log .airspace li b { font-family: ui-monospace, Menlo, monospace; font-weight: 600 }
.pilot-log .airspace li .f { font-weight: 600 }
.pilot-log .airspace li .rule { color: var(--muted); font-size: 9px }
.pilot-log .airspace li.more { display: block; color: var(--muted); font-size: 9px }
.pilot-log .empty { padding: 3px 6px; color: var(--muted); font-size: 9.5px; border-bottom: 1px solid var(--hair) }
.pilot-log .enroute { padding: 3px 6px; font-size: 10px; display: flex; flex-wrap: wrap; align-items: baseline; gap: 0 12px }
.pilot-log .enroute .item { margin: 0 }
.pilot-log .enroute.areas { border-bottom: 1px solid var(--hair); font-size: 9px }

.pilot-log .contacts { border: 1px solid var(--bad); padding: 4px 6px; font-size: 9.5px; display: grid; gap: 1px }
.pilot-log .contacts > b { color: var(--bad); font-size: 8.5px; letter-spacing: .1em; text-transform: uppercase }
.pilot-log .contacts .mono { font-weight: 600 }

.pilot-log .top { display: flex; justify-content: space-between; align-items: flex-end; gap: 8px }
.pilot-log .two { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; align-items: start }
.pilot-log .verdict { border: 1.5px solid var(--ok); color: var(--ok); background: var(--ok-bg); font-weight: 700; letter-spacing: .06em; padding: 2px 8px; text-transform: uppercase }
.pilot-log .verdict.bad { border-color: var(--bad); color: var(--bad); background: #fdecea }
.pilot-log .chart { display: block; width: 100%; height: auto }
.pilot-log .chart text { font: 9px system-ui, sans-serif; fill: var(--ink) }
.pilot-log .legend { display: flex; gap: 10px; padding: 3px 6px 0; font-size: 9.5px }
.pilot-log .legend i { display: inline-block; width: 8px; height: 8px; transform: rotate(45deg); margin-right: 4px }
.pilot-log .ad td { font-size: 9.5px }
.pilot-log .ad td.code { font-family: ui-monospace, Menlo, monospace; font-weight: 600; font-size: 11px; white-space: nowrap }
.pilot-log .src { font-size: 8px; color: var(--muted); padding: 0 6px 3px }
.pilot-log .notes { border: 1px solid var(--ink); min-height: 40px; padding: 3px 6px }
.pilot-log .notes h2 { color: var(--muted); margin: 0 }
.pilot-log .pgfoot { align-self: end; font-size: 8.5px; color: var(--muted); display: flex; justify-content: space-between; gap: 8px; border-top: 1px solid var(--hair); padding-top: 4px }
`
